<svelte:options tag={null} />

<script lang="ts">
  import { onMount } from 'svelte/internal';
  import { EventHandler } from '../../utilities/EventHandler';
  export let title: string;
  export let isopen: boolean;
  export let extended: boolean;
  export let scrollbaredge: boolean;
  export let closebuttontext = 'Close';
  export let iconname: string | undefined = undefined;
  $: isopen
    ? eventHandler.dispatch('layer-opened', {})
    : eventHandler.dispatch('layer-closed', {});
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  let root: HTMLElement;
  let eventHandler = new EventHandler();
  onMount(() => {
    const body = root.querySelector('.mc-layer__body');
    const content = root.querySelector('.mc-layer__content');
    const overflowingClass = !scrollbaredge
      ? 'mc-layer__body--overflowing'
      : 'mc-layer__body--overflowing-scroll-edge';
    if (body && content) {
      const bodyHeight = body.clientHeight;
      const contentHeight = content.scrollHeight;

      if (contentHeight > bodyHeight) {
        body.classList.add(overflowingClass);
      } else {
        body.classList.remove(overflowingClass);
      }
    }
  });

  function onClose(): void {
    isopen = false;
  }

  function generateIconName(iconname: string): string {
    return `${iconname} size="1.5rem"`;
  }
</script>

<div bind:this={root}>
  <div
    class="mc-layer"
    tabindex="-1"
    role="dialog"
    aria-labelledby="layerTitle"
    aria-modal="true"
    aria-hidden={!isopen}
    {...attributes}
  >
    <div
      class="mc-layer__dialog {isopen ? ' is-open' : ''} {extended
        ? ' mc-layer__dialog--extend'
        : ''}"
      role="document"
    >
      <div class="mc-layer__header">
        {#if iconname}
          <span class="mc-layer__icon">
            {@html `<${generateIconName(iconname)} class="mc-layer__icon" />`}
          </span>
        {/if}
        <h2 class="mc-layer__title" id="modallayerTitleTitle">{title}</h2>
        <button
          class="mc-layer__close"
          type="button"
          on:click={() => onClose()}
        >
          <span class="mc-layer__close-text">{closebuttontext}</span>
        </button>
      </div>
      <main
        class="mc-layer__body {scrollbaredge
          ? 'mc-layer__body--overflowing-scroll-edge'
          : ''}"
      >
        <article class="mc-layer__content">
          <slot name="content" />
        </article>
      </main>
      <footer class="mc-layer__footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
  <div
    class="mc-layer-overlay {isopen ? ' is-visible' : ''}"
    tabindex="-1"
    role="dialog"
    on:click={() => onClose()}
  />
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.layer';
</style>
